(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationSchedulePayment',
	};

	var $form;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Set up client search typeahead
		Adzuki.Typeahead(
			'#reservationschedulepayment-client_search',
			'/Clients/search',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			}
		);

		// Handle responsible client selection
		$('#reservationschedulepayment-client_select').change(function changeClient() {
			var $select = $(this);

			if ($select.val() === 'other') {
				$('#reservationschedulepayment-client_id').val('');

				$form.find('.client-select').addClass('hidden');
				$form.find('.client-search').removeClass('hidden');

				$('#reservationschedulepayment-client_search').focus();
			} else {
				$('#reservationschedulepayment-client_id').val($select.val());
			}
		});

		// Hook into client search reset to clean up things
		$('#reservationschedulepayment-client_search').on('ta.reset', function reset(e) {
			var $client_select = $('#reservationschedulepayment-client_select');

			$('#reservationschedulepayment-client_id').val('');

			$client_select.val($client_select.data('selected-id'));
			$client_select.trigger('change');
		});

		// Toggle client search and select
		$form.find('.select-client').click(function click(e) {
			e.preventDefault();

			$form.find('.client-search .reset-typeahead a').trigger('click');

			$form.find('.client-search').addClass('hidden');
			$form.find('.client-select').removeClass('hidden');
		});

		// load the client info
		$('#reservationschedulepayment-client_select').trigger('change');

		// adjust the soft date
		$('#reservationschedulepayment-due_date').on('dp.change', function dateChange(e) {
			var $soft_payment_date    = $('#reservationschedulepayment-soft_date'),
			    soft_payment_date     = $soft_payment_date.data('DateTimePicker'),
			    new_soft_payment_date = new Date(e.date);

			if ($(this).val() !== '') {
				new_soft_payment_date.setDate(new_soft_payment_date.getDate() - parseInt($soft_payment_date.data('soft-date-day')));

				soft_payment_date.date(new_soft_payment_date);
			}
		});
	};
}(jQuery, window.Adzuki || {}));